import { BuilderComponent } from '@builder.io/react'

import { BUILDER_BLOG_MODEL } from '@/config/builder'
import { useBlogArticleCms } from '@/providers/BlogArticleCmsProvider'

export const MedusaArticleLayout = () => {
  const { content } = useBlogArticleCms()

  return (
    <BuilderComponent
      model={BUILDER_BLOG_MODEL}
      content={content}
      options={{ includeRefs: true }}
    />
  )
}
